import { createSlice } from '@reduxjs/toolkit';

/**
 * 各カテゴリのソートされた求人数とこだわり項目名
 * @param requirements 募集・採用情報
 * @param income 年収
 * @param workplaceEnvironment 会社・職場
 * @param holidayAndWayOfWorking 休日・働き方
 * @param employeeAverageAge 社員の平均年齢
 * @param employmentStatus 雇用形態
 * @param welfareBenefits 福利厚生
 * @param positionsAndLanguageSkills 仕事内容・語学
 * @param establish 設立年数
 * @param publicationDate 更新日
 */
export interface JobTrendRankingState {
  requirements: (string[] | number[])[] | undefined;
  income: (string[] | number[])[] | undefined;
  workplaceEnvironment: (string[] | number[])[] | undefined;
  holidayAndWayOfWorking: (string[] | number[])[] | undefined;
  employeeAverageAge: (string[] | number[])[] | undefined;
  employmentStatus: (string[] | number[])[] | undefined;
  welfareBenefits: (string[] | number[])[] | undefined;
  positionsAndLanguageSkills: (string[] | number[])[] | undefined;
  establish: (string[] | number[])[] | undefined;
  publicationDate: string | undefined;
}

// 初期状態
export const jobTrendRankingInitialState: JobTrendRankingState = {
  requirements: undefined,
  income: undefined,
  workplaceEnvironment: undefined,
  holidayAndWayOfWorking: undefined,
  employeeAverageAge: undefined,
  employmentStatus: undefined,
  welfareBenefits: undefined,
  positionsAndLanguageSkills: undefined,
  establish: undefined,
  publicationDate: undefined,
};

/**
 * State型
 * @param jobTrendRanking 各カテゴリのソートされた配列
 */
export interface JobTrendRankingSliceState {
  jobTrendRanking: ReturnType<typeof jobTrendRankingReducer>;
}

const jobTrendRankingSlice = createSlice({
  name: 'jobTrendRanking',
  initialState: jobTrendRankingInitialState,
  reducers: {
    setRequirements: (state, action) => {
      state.requirements = action.payload;
    },
    setIncome: (state, action) => {
      state.income = action.payload;
    },
    setWorkplaceEnvironment: (state, action) => {
      state.workplaceEnvironment = action.payload;
    },
    setHolidayAndWayOfWorking: (state, action) => {
      state.holidayAndWayOfWorking = action.payload;
    },
    setEmployeeAverageAge: (state, action) => {
      state.employeeAverageAge = action.payload;
    },
    setEmploymentStatus: (state, action) => {
      state.employmentStatus = action.payload;
    },
    setWelfareBenefits: (state, action) => {
      state.welfareBenefits = action.payload;
    },
    setPositionsAndLanguageSkills: (state, action) => {
      state.positionsAndLanguageSkills = action.payload;
    },
    setEstablish: (state, action) => {
      state.establish = action.payload;
    },
    setPublicationDate: (state, action) => {
      state.publicationDate = action.payload;
    },
  },
});

// Create Action
export const {
  setRequirements,
  setIncome,
  setWorkplaceEnvironment,
  setHolidayAndWayOfWorking,
  setEmployeeAverageAge,
  setEmploymentStatus,
  setWelfareBenefits,
  setPositionsAndLanguageSkills,
  setEstablish,
  setPublicationDate,
} = jobTrendRankingSlice.actions;

// reducer
export const jobTrendRankingReducer = jobTrendRankingSlice.reducer;

/**
 * selector
 * @param state
 * @returns 各カテゴリのソートされた配列
 */
export const jobTrendRankingSelector = (state) => state.jobTrendRanking;
